import React from 'react'
import { Grid, Typography} from "@material-ui/core"
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    icon: {
        fill:"#e74c3c",
    },
    errorText: {
        color: theme.palette.textColor3.main,
    }
}))




const PageNotFound = (props) => {
    const classes = useStyles()
    return (
        <Grid container alignItems="center" direction="column" justifyContent="center" style={{ height: "calc(100vh - 64px)" }}>
            <div style = {{marginBottom:25}}>
                <svg
                    x="0px"
                    y="0px"
                    width="256"
                    height="256"
                    viewBox="0 0 128 128"
                    className={classes.icon}
                >
                    <path d="M 14 1 C 6.8 1 1 6.8 1 14 L 1 24 L 1 28 C 1 29.7 2.3 31 4 31 L 124 31 C 125.7 31 127 29.7 127 28 L 127 14 C 127 6.8 121.2 1 114 1 L 14 1 z M 18 13 L 22 13 C 23.7 13 25 14.3 25 16 C 25 17.7 23.7 19 22 19 L 18 19 C 16.3 19 15 17.7 15 16 C 15 14.3 16.3 13 18 13 z M 34 13 L 38 13 C 39.7 13 41 14.3 41 16 C 41 17.7 39.7 19 38 19 L 34 19 C 32.3 19 31 17.7 31 16 C 31 14.3 32.3 13 34 13 z M 76 13 L 110 13 C 111.7 13 113 14.3 113 16 C 113 17.7 111.7 19 110 19 L 76 19 C 74.3 19 73 17.7 73 16 C 73 14.3 74.3 13 76 13 z M 4 37 C 2.3 37 1 38.3 1 40 L 1 114 C 1 121.2 6.8 127 14 127 L 114 127 C 121.2 127 127 121.2 127 114 L 127 40 C 127 38.3 125.7 37 124 37 L 4 37 z M 64 58.5 C 70.1 58.5 75 63.4 75 69.5 L 75 90.5 C 75 96.6 70.1 101.5 64 101.5 C 57.9 101.5 53 96.6 53 90.5 L 53 69.5 C 53 63.4 57.9 58.5 64 58.5 z M 42.28125 58.529297 C 42.452148 58.539258 42.625781 58.562109 42.800781 58.599609 C 44.200781 58.899609 45.099609 60.1 45.099609 61.5 L 45.099609 88.5 C 46.799609 88.5 48.099609 89.8 48.099609 91.5 C 48.099609 93.2 46.7 94.5 45 94.5 L 45 98.5 C 45 100.2 43.7 101.5 42 101.5 C 40.3 101.5 39 100.2 39 98.5 L 39 94.5 L 28 94.5 C 26.3 94.5 25 93.2 25 91.5 L 25 87.5 C 25 87 25.100391 86.499609 25.400391 86.099609 L 39.400391 60.099609 C 40.012891 59.049609 41.084961 58.45957 42.28125 58.529297 z M 97.28125 58.529297 C 97.452148 58.539258 97.625781 58.562109 97.800781 58.599609 C 99.100781 58.899609 100.09961 60.1 100.09961 61.5 L 100.09961 88.5 C 101.79961 88.5 103.09961 89.8 103.09961 91.5 C 103.09961 93.2 101.7 94.5 100 94.5 L 100 98.5 C 100 100.2 98.7 101.5 97 101.5 C 95.3 101.5 94 100.2 94 98.5 L 94 94.5 L 83 94.5 C 81.3 94.5 80 93.2 80 91.5 L 80 87.5 C 80 87 80.100391 86.499609 80.400391 86.099609 L 94.400391 60.099609 C 95.012891 59.049609 96.084961 58.45957 97.28125 58.529297 z M 64 64.5 C 61.2 64.5 59 66.7 59 69.5 L 59 90.5 C 59 93.3 61.2 95.5 64 95.5 C 66.8 95.5 69 93.3 69 90.5 L 69 69.5 C 69 66.7 66.8 64.5 64 64.5 z M 39 73.400391 L 31 88.300781 L 31 88.5 L 39 88.5 L 39 73.400391 z M 94 73.400391 L 86 88.300781 L 86 88.5 L 94 88.5 L 94 73.400391 z" />
                </svg>
            </div>
            <Typography className={classes.errorText}>
                Page Not Found
            </Typography>
        </Grid>
    )
}

export default PageNotFound